module.exports = __webpack_public_path__ + "img/33-indian.d03be249.svg";